import { render, staticRenderFns } from "./RightChatbot.vue?vue&type=template&id=90343b2a&scoped=true&"
import script from "./RightChatbot.vue?vue&type=script&lang=js&"
export * from "./RightChatbot.vue?vue&type=script&lang=js&"
import style0 from "./RightChatbot.vue?vue&type=style&index=0&id=90343b2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90343b2a",
  null
  
)

export default component.exports